/**
 * WARNING: The use of `require` and `module.exports` is because this package has to remain
 * in CommonJS format. Do not change ANY files here to ES6 standards or it will break usages.
 */

"use strict";

const Agelocme = require("./agelocme.js");
const Contentstack = require('./contentstack/contentstack');
const PriceType = require("./models/priceType.js");
const Product = require("./product.js");
const ProductContentMapper = require("./productContentMapper.js");
const ProductStatus = require("./models/productStatus.js");
const ProductStatusMapper = require("./productStatusMapper.js");
const ProductUtils = require("./productUtils.js");
const ProductData = require("./productData.js");
const CustomerTypes = require('./models/customerTypes');

module.exports = {
  Agelocme,
  Contentstack,
  PriceType,
  Product,
  ProductContentMapper,
  ProductStatus,
  ProductStatusMapper,
  ProductUtils,
  ProductData,
  CustomerTypes
};
